interface FloatingOrbsProps {
  variant?: "blue" | "mixed";
  className?: string;
}

export function FloatingOrbs({ variant = "blue", className = "" }: FloatingOrbsProps) {
  if (variant === "mixed") {
    return (
      <div aria-hidden className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
        <div className="orb w-72 h-72 bg-[hsl(199_100%_38%/0.15)] top-[10%] left-[15%] animate-float" />
        <div className="orb w-96 h-96 bg-[hsl(193_100%_46%/0.10)] top-[50%] right-[10%] animate-float-delayed" />
        <div className="orb w-64 h-64 bg-[hsl(40_100%_60%/0.08)] bottom-[10%] left-[40%] animate-float-slow" />
      </div>
    );
  }

  return (
    <div aria-hidden className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
      <div className="orb w-80 h-80 bg-[hsl(199_100%_38%/0.12)] top-[5%] left-[10%] animate-float" />
      <div className="orb w-96 h-96 bg-[hsl(193_100%_46%/0.08)] top-[40%] right-[5%] animate-float-delayed" />
      <div className="orb w-64 h-64 bg-[hsl(199_100%_50%/0.10)] bottom-[15%] left-[35%] animate-float-slow" />
    </div>
  );
}
